<ng-container *transloco="let t">
  <div class="flex h-[50rem] w-[min(75rem,_90vw)] flex-col gap-4">
    <div class="flex justify-end">
      <IButton [label]="'New User'" icon="icon-[mdi--plus]" (onClick)="openNewUserModal()" size="sm" />
    </div>

    <div class="flex flex-1 flex-col gap-2">
      <IInput
        [placeholder]="t('manage-authorized-users-modal.search_by_name_or_email')"
        icon="icon-[mdi--search]"
        class="w-full"
        size="sm"
        autoFocus
        (valueChange)="externalFilterChanged($event)"
      />

      <div class="ag-theme-quartz ag-theme-quartz-light flex-1">
        <ag-grid-angular
          [rowData]="gridData()"
          class="h-full"
          [gridOptions]="gridOptions"
          [isExternalFilterPresent]="isExternalFilterPresent"
          [doesExternalFilterPass]="doesExternalFilterPass"
        />
      </div>
    </div>
  </div>
  <ng-template #newUserModal>
    <div class="flex w-[30rem] flex-col gap-4">
      @if (isEmailRegistered() === false) {
        <IAlert [title]="t('manage-authorized-access-modal.email_description')" />
      }
      <IInput
        [placeholder]="t('manage-authorized-users-modal.email_of_the_user_to_invite')"
        [control]="emailControl"
        size="sm"
        class="w-full"
        autoFocus
      />

      <div>
        <div class="mb-2 text-sm font-medium tracking-tight text-gray-700">
          {{ t("manage-authorized-users-modal.access_level") }}
        </div>
        <ISelect
          [options]="accessLevelOptions"
          [selectedValue]="accessLevel"
          (selectedOptionChange)="accessLevel = $event.value"
          class="w-full"
        />
      </div>

      <div class="flex justify-end gap-2">
        <IButton [label]="t('common.cancel')" color="white" (onClick)="newUserModalRef?.close()" />

        <IButton
          [label]="t('manage-authorized-users-modal.add_user')"
          (onClick)="addNewUser()"
          [disabled]="!emailControl.valid"
          [loading]="callLoading()"
        />
      </div>
    </div>
  </ng-template>
</ng-container>
